import React from "react";
import { Bar, Entry, Legend, Root } from "./CoverageMeter.styles";
import type { CoverageMeterProps } from "./CoverageMeter.types";

/** Coverage at a glance: one bar plus a legend such as "171 ready · 1 to fix · 14 with no one". */
export const CoverageMeter: React.FC<CoverageMeterProps> = ({ segments, className }) => {
  const shown = segments.filter((segment) => segment.count > 0);
  if (!shown.length) return null;
  return (
    <Root className={className} data-testid="coverage-meter">
      <Bar segments={shown.map(({ count, tone }) => ({ value: count, tone }))} />
      <Legend>
        {shown.map((segment) => (
          <Entry key={`${segment.tone}-${segment.label}`} $tone={segment.tone} data-tone={segment.tone}>
            {segment.count} {segment.label}
          </Entry>
        ))}
      </Legend>
    </Root>
  );
};

export default CoverageMeter;
